import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Forms from "../../../../Componets/Form";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import { create_credit_note, get_credit_note } from "../../../../Controllers/Sales/CreditNotes";
import { get_invoice } from "../../../../Controllers/Sales/Invoices";
import forms from "../../../../Data/Forms/Sales/CreditNote/forms";
import headers from "../../../../Data/Forms/Sales/CreditNote/headers";
import Loadercomponent from "../../../../Componets/Loader";
import Bodycomponent from "../../../../Componets/Formcomponents/body";
import Titlecomponent from "../../../../Componets/Formcomponents/title";
import Formdata from "../../../../Componets/Formcomponents/formdata";
import Headercomponent from "../../../../Componets/Formcomponents/header";
import CreditNoteTable from "../../../../Data/Forms/Sales/CreditNote/table";

const CreditNotesForm = () => {
  let { id } = useParams();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [header, setHeader] = useState(headers);
  const [values, setValues] = useState(forms);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [details, setDetails] = useState([]);
  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    total: "0.000",
  });

  const focus = useRef([]);

  const findFieldIndex = (fieldName) => {
    return values[0].options.findIndex((option) => option.name === fieldName);
  };

  const handleInvoiceChange = async (invoiceId) => {
    if (!invoiceId) {
      setSelectedInvoice(null);
      setDetails([]);
      updateCustomerField("");
      return;
    }

    try {
      const invoice = await get_invoice({ id: invoiceId });

      if (invoice?.status) {
        setSelectedInvoice(invoice.data);

        updateCustomerField(invoice.data.customer?.name || "Walk-in-customer");

        const creditNoteDetails = invoice.data.details
          .filter(item => item.unit_name?.toLowerCase() !== "service")
          .map(item => ({
            ...item,
            original_quantity: item.quantity,
            quantity: item.quantity,
            id: item._id,
          }));

        setDetails(creditNoteDetails);
        calculateTotals(creditNoteDetails);
      } else {
        toast.error("Failed to load invoice details");
      }
    } catch (error) {
      toast.error("Error loading invoice");
    }
  };

  const updateCustomerField = (customerName) => {
    console.log("vluuuuu", values, customerName)
    const currentValues = [...values];
    const customerIndex = findFieldIndex("Customer");
    if (customerIndex !== -1) {
      currentValues[0].options[customerIndex].form.value = customerName;
      setValues(currentValues);
    }
  };

  const calculateTotals = (items) => {
    const subtotal = items.reduce((sum, item) => sum + (parseFloat(item.sale_price) * parseFloat(item.quantity || 0)), 0);
    const taxamount = items.reduce((sum, item) => sum + parseFloat(item.tax_amount || 0), 0);
    const total = subtotal + taxamount;

    setTotals({
      subtotal: subtotal.toFixed(3),
      taxamount: taxamount.toFixed(3),
      discount: 0,
      delivery: 0,
      total: total.toFixed(3),
    });
  };

  const handleDetailChange = (index, field, value) => {
    const updatedDetails = [...details];
    updatedDetails[index][field] = value;

    if (field === 'quantity' || field === 'sale_price') {
      const item = updatedDetails[index];
      const quantity = parseFloat(item.quantity || 0);
      const salePrice = parseFloat(item.sale_price || 0);
      const taxRate = item.tax?.rate ? parseFloat(item.tax.rate) : 0;

      const subtotal = quantity * salePrice;
      const taxAmount = subtotal * (taxRate / 100);
      const total = subtotal + taxAmount;

      updatedDetails[index].tax_amount = taxAmount;
      updatedDetails[index].total = total;
    }

    setDetails(updatedDetails);
    calculateTotals(updatedDetails);
  };

  const handleRemoveDetail = (index) => {
    const updatedDetails = details.filter((_, i) => i !== index);
    setDetails(updatedDetails);
    calculateTotals(updatedDetails);
  };

  const formdata = async (data) => {
    if (data?.status) {
      const formData = data.data;

      if (!formData.invoice) {
        toast.error("Please select an invoice");
        return;
      }

      if (!formData.reason) {
        toast.error("Please enter a reason for the credit note");
        return;
      }

      const validDetails = details.filter(item => parseFloat(item.quantity || 0) > 0);

      if (validDetails.length === 0) {
        toast.error("Please add at least one item to return");
        return;
      }

      setButtonLoader(true);

      const creditNoteData = {
        invoice: formData.invoice,
        customer: selectedInvoice?.customer?._id,
        date: formData.date,
        reason: formData.reason,
        details: validDetails,
        subtotal: totals.subtotal,
        taxamount: totals.taxamount,
        discount: totals.discount,
        delivery: totals.delivery,
        total: totals.total,
      };

      const creditNote = id
        ? null
        : await create_credit_note(creditNoteData);

      if (creditNote?.status) {
        navigate("/app/sales/credit-notes");
        toast.success(creditNote?.message);
      } else {
        toast.error(creditNote?.message || "Failed to create credit note");
      }

      setButtonLoader(false);
    }
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);
      const creditNote = await get_credit_note({ id });
      if (creditNote?.status) {
        const data = creditNote.data;
        const currentValues = [...values];

        const invoiceIndex = findFieldIndex("Invoice");
        const dateIndex = findFieldIndex("Date");
        const reasonIndex = findFieldIndex("Reason");
        const customerIndex = findFieldIndex("Customer");

        if (invoiceIndex !== -1) {
          currentValues[0].options[invoiceIndex].form.value = data.invoice?._id;
          currentValues[0].options[invoiceIndex].form.options = [
            { value: data.invoice?._id, label: `#INV-${data.invoice?.number}` }
          ];
        }

        if (dateIndex !== -1) {
          currentValues[0].options[dateIndex].form.value = data.date;
        }

        if (reasonIndex !== -1) {
          currentValues[0].options[reasonIndex].form.value = data.reason;
        }

        if (customerIndex !== -1) {
          currentValues[0].options[customerIndex].form.value = data.customer?.name || "Walk-in-customer";
        }

        setValues(currentValues);
        setSelectedInvoice(data.invoice);
        setDetails(data.details || []);
        setTotals({
          subtotal: data.subtotal?.toFixed(3) || "0.000",
          taxamount: data.taxamount?.toFixed(3) || "0.000",
          discount: data.discount || 0,
          delivery: data.delivery || 0,
          total: data.total?.toFixed(3) || "0.000",
        });
      } else {
        toast.error(creditNote?.message);
      }
      setLoader(false);
    } else {
      const currentValues = [...values];
      const dateIndex = findFieldIndex("Date");
      if (dateIndex !== -1) {
        currentValues[0].options[dateIndex].form.value = new Date();
      }
      setValues(currentValues);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [id]);

  const previousInvoiceRef = useRef(null);


  const setFormData = (data) => {
    setValues(data);

    const invoiceIndex = findFieldIndex("Invoice");
    if (invoiceIndex !== -1) {
      const invoiceField = data[0].options[invoiceIndex].form;
      const invoiceValue = invoiceField.value;

      if (
        invoiceValue &&
        previousInvoiceRef.current !== invoiceValue
      ) {
        previousInvoiceRef.current = invoiceValue;
        invoiceField.onChange = handleInvoiceChange(invoiceValue);
      }
    }
  };

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <Forms
          form={values}
          setForm={setFormData}
          formdata={formdata}
          buttonLoader={buttonLoader}
        >
          <Bodycomponent>
            <Titlecomponent index={1} title={"Return Items"} />
            <Formdata>
              <Headercomponent index={0} name={"Items to Return"} required={true} />
              <CreditNoteTable
                details={details}
                setDetails={setDetails}
                onDetailChange={handleDetailChange}
                onRemoveDetail={handleRemoveDetail}
                totals={totals}
                ref={focus}
                readOnly={!!id}
              />
            </Formdata>
          </Bodycomponent>
        </Forms>
      </Loadercomponent>
    </Header>
  );
};

export default CreditNotesForm;